/* eslint-disable jsx-a11y/label-has-associated-control */
// @flow
import * as React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import DatePicker from './DatePickerField';

function addMachineForm({ setErrorMessage, fetchReports }: any): React$Element<any> {
  return (
    <Formik
      initialValues={{
        type: '',
        startDate: new Date(),
        endDate: new Date(),
        crusher: '',
        vehicleNumber: '',
        lotNumber: '',
        auction: '',
      }}
      validate={(values) => {
        const errors = {};
        if (!values.type) {
          errors.type = 'Required';
        } else if (
          !/^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/i.test(
            values.type,
          )
        ) {
          errors.type = 'Invalid host or ip address';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          const payload = {
            startDate: values.startDate.toISOString().split('T')[0],
            endDate: values.endDate.toISOString().split('T')[0],
            type: values.type,
          };
          switch (values.type) {
            case 'crusher':
              payload.type = 'company';
              payload.typeValue = values.crusher;
              break;
            case 'lot':
              payload.type = 'lotNumber';
              payload.typeValue = values.lotNumber;
              break;
            case 'auction':
              payload.type = 'auctionReferenceNumber';
              payload.typeValue = values.auction;
              break;
            default:
              payload.type = 'vehicleNumber';
              payload.typeValue = values.vehicleNumber;
              break;
          }
          fetchReports(payload);
          setSubmitting(false);
        }, 400);
      }}
    >
      {({ errors, touched, isSubmitting, values }) => (
        <Form className="col-md-12 p-0">
          <div className="form-group">
            <label className="form-label d-block" htmlFor="startDate">
              From:
            </label>
            <DatePicker
              selected={values.startDate}
              name="startDate"
              id="startDate"
              className={`form-control d-block ${
                errors.startDate !== undefined && touched.startDate !== undefined ? 'is-invalid' : touched.startDate && ' is-valid '
              }`}
            />
            <ErrorMessage name="startDate" render={(msg) => <div className="invalid-feedback">{msg}</div>} />
          </div>

          <div className="form-group">
            <label className="form-label d-block" htmlFor="endDate">
              To:
            </label>
            <DatePicker
              selected={values.endDate}
              name="endDate"
              id="endDate"
              minDate={values.startDate}
              className={`form-control ${
                errors.endDate !== undefined && touched.endDate !== undefined ? 'is-invalid' : touched.endDate && ' is-valid '
              }`}
            />
            <ErrorMessage name="endDate" render={(msg) => <div className="invalid-feedback">{msg}</div>} />
          </div>
          <div className="form-group">
            <label className="form-label d-block" htmlFor="name">
              Type:
            </label>
            <Field
              as="select"
              name="type"
              id="type"
              className={`form-control ${errors.type !== undefined && touched.type !== undefined ? 'is-invalid' : touched.type && ' is-valid '}`}
              placeholder="Select type"
            >
              <option value="" disabled>
                (Make a Selection)
              </option>
              <option value="vehicle">Vehicle</option>
              <option value="crusher">Crusher</option>
              <option value="lot">Pit</option>
              <option value="auction">Auction</option>
            </Field>
            <ErrorMessage name="type" render={(msg) => <div className="invalid-feedback">{msg}</div>} />
          </div>
          {values.type === 'vehicle' && (
            <div className="form-group">
              <label className="form-label d-block" htmlFor="vehicleNumber">
                Vehicle Number:
              </label>
              <Field
                type="text"
                name="vehicleNumber"
                id="vehicleNumber"
                className={`form-control ${
                  errors.vehicleNumber !== undefined && touched.vehicleNumber !== undefined ? 'is-invalid' : touched.vehicleNumber && ' is-valid '
                }`}
                placeholder="Vehicle Number"
              />
              <ErrorMessage name="vehicleNumber" render={(msg) => <div className="invalid-feedback">{msg}</div>} />
            </div>
          )}

          {values.type === 'lot' && (
            <div className="form-group">
              <label className="form-label d-block" htmlFor="lotNumber">
                Pit Number:
              </label>
              <Field
                type="text"
                name="lotNumber"
                id="lotNumber"
                className={`form-control ${
                  errors.lotNumber !== undefined && touched.lotNumber !== undefined ? 'is-invalid' : touched.lotNumber && ' is-valid '
                }`}
                placeholder="Pit Number"
              />
              <ErrorMessage name="lotNumber" render={(msg) => <div className="invalid-feedback">{msg}</div>} />
            </div>
          )}

          {values.type === 'crusher' && (
            <div className="form-group">
              <label className="form-label d-block" htmlFor="crusher">
                Crusher Name:
              </label>
              <Field
                type="text"
                name="crusher"
                id="crusher"
                className={`form-control ${
                  errors.crusher !== undefined && touched.crusher !== undefined ? 'is-invalid' : touched.crusher && ' is-valid '
                }`}
                placeholder="Crusher Name"
              />
              <ErrorMessage name="crusher" render={(msg) => <div className="invalid-feedback">{msg}</div>} />
            </div>
          )}

          {values.type === 'auction' && (
            <div className="form-group">
              <label className="form-label d-block" htmlFor="crusher">
                Auction Reference Number:
              </label>
              <Field
                type="text"
                name="auction"
                id="auction"
                className={`form-control ${
                  errors.auction !== undefined && touched.auction !== undefined ? 'is-invalid' : touched.auction && ' is-valid '
                }`}
                placeholder="Auction Reference Number"
              />
              <ErrorMessage name="auction" render={(msg) => <div className="invalid-feedback">{msg}</div>} />
            </div>
          )}

          {setErrorMessage && (
            <div className="alert alert-soft-danger">
              <div className="d-flex flex-wrap">
                <div className="mr-8pt">
                  <i className="material-icons">report</i>
                </div>
                <div className="flex" style={{ minWidth: '180px' }}>
                  <small className="text-100">{setErrorMessage}</small>
                </div>
              </div>
            </div>
          )}
          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
            Generate Report
          </button>
        </Form>
      )}
    </Formik>
  );
}

export default addMachineForm;
